import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Link, Route, Switch } from 'react-router-dom';

import GiftcardLookup from './scenes/GiftcardLookup/index';
import Dashboard from "./scenes/Dashboard/index";
import NotFound from "./scenes/NotFound/index";
import MemberLookup from "./scenes/MemberLookup/index";
import ViewMember from "./scenes/MemberLookup/scenes/ViewMember/index";
import EditMember from "./scenes/MemberLookup/scenes/EditMember/index";
import UpdateHistory from "./scenes/MemberLookup/scenes/UpdateHistory/index";
import TransactionHistory from "./scenes/MemberLookup/scenes/TransactionHistory/index";
import NewMember from "./scenes/NewMember/index";
import NewStore from "./scenes/NewStore/index";
import NewUsers from "./scenes/NewUsers/index";
import MultiUserEdit from './scenes/NewUsers/components/MultiUserEdit';
import EditUser from "./scenes/NewStore/users";
import EditStore from "./scenes/NewStore/EditStore/index";
import Login from "./scenes/Login";
import Logout from "./scenes/Logout";
import ResetPassword from "./scenes/ResetPassword";
import AdminTools from './scenes/AdminTools';
import AuthService from './services/AuthService';
import JobDetails from './scenes/AdminTools/components/components/JobDetails';
import RolesAndPermissions from './scenes/RolesAndPermissions';
import AreaManagers from './scenes/AreaManagers';
import SecurityQuestions from './scenes/SecurityQuestions';
import News from './scenes/News';
import Analytics from './scenes/Analytics';
import IoLogs from './scenes/IoLogs';

class App extends React.Component {

    render() {
        return (
            <BrowserRouter>
                <Switch>
                    <Route exact path='/login' component={Login} />
                    <Route exact path='/reset/:id' component={ResetPassword} />
                    <Route exact path='/security/:id' component={SecurityQuestions} />
                    <Route exact path='/logout' component={Logout} />
                    <Route exact path='/' component={Dashboard} />
                    <Route exact path='/giftcards' component={GiftcardLookup} />
                    <Route path='/giftcards/:cardNumber' component={GiftcardLookup} />
                    <Route exact path='/members' component={MemberLookup} />
                    <Route path='/members/:id/edit' component={EditMember} />
                    <Route path='/members/:id/viewPurchaseHistory' component={TransactionHistory} />
                    <Route path='/members/:id/viewUpdateHistory' component={UpdateHistory} />
                    <Route path='/members/:id' component={ViewMember} />
                    <Route exact path='/new-member' component={NewMember} />
                    <Route exact path='/new-store' component={NewStore} />
                    <Route exact path='/admintools' component={Analytics} />
                    <Route exact path='/admin' component={AdminTools} />
                    <Route exact path='/roles_permissions' component={RolesAndPermissions} />
                    <Route exact path='/admintools/jobs/:id/:cat' component={JobDetails} />
                    <Route exact path='/new-users' component={NewUsers} />
                    <Route exact path='/area-managers' component={AreaManagers} />
                    <Route exact path='/new-store/:id/edit/:slug' component={EditStore} />
                    {/* {(AuthService.getAdminType() == 1 || AuthService.getAdminType() == 2) &&  */}
                        <Route exact path='/user/:id/edit/:name' component={EditUser} />
                    {/* }
                    {(AuthService.getAdminType() == 1 || AuthService.getAdminType() == 2 || AuthService.getAdminType() == 4) &&  */}
                        <Route exact path='/multiUser/:id' component={MultiUserEdit} />
                    {/* } */}
                    <Route exact path='/news' component={News} />
                    <Route exact path='/io-logs' component={IoLogs} />
                    {/* <Route exact path='/new-store/:id/edit' component={EditStore} /> */}
                    <Route component={NotFound} />
                </Switch>
            </BrowserRouter>
        );
    }
}

ReactDOM.render(<App />, document.getElementById('app'));
